import React from "react";

function HomeBannerSVG() {
  return (
    <>
      <svg
        className="error-svg"
        width="44"
        height="49"
        viewBox="0 0 44 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.857037 3.16623C18.4788 3.16623 33.2257 19.288 35.5 36.1133"
          stroke="url(#paint0_linear_345_66)"
          stroke-width="5"
        />
        <circle cx="36" cy="40.1133" r="6" stroke="#0F6B4F" stroke-width="4" />
        <defs>
          <linearGradient
            id="paint0_linear_345_66"
            x1="31.1309"
            y1="38.6409"
            x2="18.1237"
            y2="1.01398"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#5AE5B3" />
            <stop offset="1" stop-color="#2ED19E" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
}

export default HomeBannerSVG;
